export const CENTRAL_AUTH_URL = process.env.REACT_APP_CENTRAL_AUTH_URL || 'https://8qokxijv7c.execute-api.us-east-1.amazonaws.com/test/mirror';
export const UI_VERSION = process.env.REACT_APP_UI_VERSION;
export const STAGE = process.env.REACT_APP_STAGE;
export const TENANT_ID = process.env.REACT_APP_TENANT_ID;
export const ENDPOINT_URL = process.env.REACT_APP_ENDPOINT_URL;
export const SESSION_ID = process.env.REACT_APP_SESSION_ID;
export const ETO_SECURITY_TOKEN = process.env.REACT_APP_ETO_SECURITY_TOKEN;
export const ENTERPRISE_GUID = process.env.REACT_APP_ENTERPRISE_GUID;
export const APRICOT_FORCE_SSO_LOGIN = process.env.REACT_APP_APRICOT_FORCE_SSO_LOGIN;
export const ETO_FORCE_SSO_LOGIN = process.env.REACT_APP_ETO_FORCE_SSO_LOGIN;
export const MULTI_USER_POOLS = process.env.REACT_APP_MULTI_USER_POOLS;
